import React, { useState, useEffect } from 'react';
import s from '../SliderBigIMG.module.css';
import { useAppTranslation } from "./TranslationContext";

export const SliderBigIMG = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [students, setStudents] = useState([]);
  const { t } = useAppTranslation();

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        // 1. Получаем список пользователей с ilmiy_daraja === 3
        const res = await fetch('https://api.rasulova-academy.uz/api/custom-users/');
        const data = await res.json();
        const filtered = data.filter(item => item.ilmiy_daraja === 3);

        // 2. Для каждого делаем запрос на получение имени и фамилии
        const studentsData = await Promise.all(
          filtered.map(async (item) => {
            const userRes = await fetch(`https://api.rasulova-academy.uz/api/users/${item.user}`);
            const userData = await userRes.json();

            return {
              img: item.img,
              name: `${userData.first_name} ${userData.last_name} ${item.otasining_ismi}`,
              job: item.description
            };
          })
        );

        setStudents(studentsData);
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };

    fetchStudents();
  }, []);

  const cardWidth = window.innerWidth <= 768 ? window.innerWidth * 0.9 : 384;
  const visibleCards = window.innerWidth <= 768 ? 1 : window.innerWidth <= 1024 ? 2 : 3;
  const stepWidth = cardWidth * visibleCards + 20 * (visibleCards - 1);
  const maxSteps = Math.ceil(students.length / visibleCards) - 1;

  const moveLeft = () => {
    if (currentStep > 0) setCurrentStep(prev => prev - 1);
  };

  const moveRight = () => {
    if (currentStep < maxSteps) setCurrentStep(prev => prev + 1);
  };

  const translateX = -currentStep * stepWidth;

  return (
    <div className={s.sliderStudents}>
      <div className={s.unify}>
        <p className={s.sliderStudentTitle}>{t('teachersTitle')}</p>
        <div className={s.btns}>
          <button onClick={moveLeft} disabled={currentStep === 0}>
            <img className={s.slider__button__prev} src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="prev" />
          </button>
          <button onClick={moveRight} disabled={currentStep === maxSteps}>
            <img className={s.slider__button__next} src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="next" />
          </button>
        </div>
      </div>

      <div
        className={s.slidesStudents}
        style={{ transform: `translateX(${translateX}px)` }}
      >
        {students.map((student, index) => (
          <div className={s.students} key={index}>
            <div className={s.slideStudentsContents}>
              <img
                src={student.img}
                className={s.studentAvatar}
                alt={student.name}
              />
              <div>
                <p className={s.studentName}>{student.name}</p>
                <p className={s.studentJob}>{student.job}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
